import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class UserPasswordChangeService {

  constructor(private http: HttpClient, private settings: AppSettings) { }

  submit(form: any, id: number): Observable<any> {
    return this.http.post(`${this.settings.oauth.url}/api/password/change/${id}`, form);
  }
}
